export default __webpack_public_path__ + "static/media/socials.f236d74d.svg";